// import loadImage from 'blueimp-load-image'
import { convertImageDataToBlob, convertBlobToFile, convertBlobToDataUrl } from './blob-utils'

export type ImageBlob = {
  blob: Blob
  image: HTMLImageElement
  file?: File
}

export function isImageType (type: string | undefined) {
  const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/*']
  return !!type && imageTypes.includes(type)
}

export async function getImageBlob (input: File | Blob | string | ImageBlob): Promise<ImageBlob> {
  if (input && typeof input === 'object' && 'blob' in input && 'image' in input) {
    return input as ImageBlob
  }

  let file: File | undefined
  if (input instanceof File) {
    file = input
  }
  let blob = await convertImageDataToBlob(input)

  // URL.createObjectURL 호환성을 위해 Blob이 유효한지 확인
  // convertBlobToFile에서 생성된 Object.create(blob) 객체는 URL.createObjectURL에서 동작하지 않을 수 있음
  try {
    // Blob 유효성 테스트: URL.createObjectURL이 동작하는지 확인
    const testUrl = URL.createObjectURL(blob)
    URL.revokeObjectURL(testUrl)
  } catch (error) {
    console.warn('[attachment:image] getImageBlob: Blob이 URL.createObjectURL과 호환되지 않음, 재생성:', error)
    // Blob을 ArrayBuffer를 통해 재생성하여 순수한 Blob으로 만듦
    try {
      const arrayBuffer = await blob.arrayBuffer()
      blob = new Blob([arrayBuffer], { type: blob.type })
    } catch (rebuildError) {
      console.error('[attachment:image] getImageBlob: Blob 재생성 실패:', rebuildError)
      throw rebuildError
    }
  }

  const image = await loadImageFromBlob(blob)
  return { blob, image, file }
}

export function getImageSize (iBlob: ImageBlob): {width: number, height: number} {
  const image = iBlob.image
  return { width: image.width, height: image.height }
  // return new Promise((resolve, reject) => {
  //   if ((file instanceof File) || (file instanceof Blob)) {
  //     const fr = new FileReader
  //     fr.onload = function () {
  //       const img = new Image
  //       img.onload = function () {
  //         resolve({ width: img.width, height: img.height })
  //       }
  //       if (!fr.result) {
  //         resolve({ width: 256, height: 256 })
  //       }
  //       img.src = fr.result as string
  //     }
  //     fr.readAsDataURL(file)
  //   } else {
  //     const img = new Image()
  //     img.onload = function () {
  //       resolve({ width: img.width, height: img.height })
  //     }
  //     img.src = file
  //   }
  // })
}

export async function makeImageThumbnail (file: File | Blob | string | ImageBlob, maxWidth = 192, maxHeight = 192, cropAspectRatio?: number, quality?: number): Promise<string> {
  try {
    const dataUrl = await resizeImageFileToDataUrl(file, '', maxWidth, maxHeight, cropAspectRatio, quality)
    if (!dataUrl || dataUrl.length === 0) {
      throw new Error('makeImageThumbnail: Failed to generate thumbnail - empty result')
    }
    // alert('[makeImageThumbnail] DataURL 생성 완료\n길이: ' + dataUrl.length)
    return dataUrl
  } catch (error) {
    console.error('[makeImageThumbnail] Error:', error)
    throw error
  }
  // const f = file as File
  // if (file instanceof File) {
  //   // alert('makeImageThumbnail: File 입니다.')
  // } else {
  //   if (typeof file === 'string') {
  //     // alert('makeImageThumbnail: 문자열 입니다.')
  //   } else {
  //     // alert('makeImageThumbnail: Blob 입니다.')
  //   }
  // }

  // // // let image = file
  // // let image: Blob | string = await fileToDataUrl(file as File)

  // const resized = await resizeImage(f, {
  //   maxWidth,
  //   maxHeight,
  // })
  // // alert('makeImageThumbnail: resized size = ' + (resized ? resized.size : 'null'))
  // if (resized) {
  //     blobSize: resized.size,
  //     blobType: resized.type,
  //     fileName: f.name,
  //     fileType: f.type,
  //   })
  //   // alert('makeImageThumbnail: Blob 확인\n' +
  //   // 'Blob Size: ' + resized.size + '\n' +
  //   // 'Blob Type: ' + resized.type + '\n' +
  //   // 'File Name: ' + f.name)

  //   try {
  //     // Android WebView에서 File 생성자가 FileReader와 호환되지 않을 수 있음
  //     // Blob을 직접 사용하여 DataURL로 변환
  //     // alert('makeImageThumbnail: Blob → DataURL 변환 시도')

  //     const dataUrl = await convertBlobToDataUrl(resized)
  //     // alert('makeImageThumbnail: DataURL 생성 완료\n길이: ' + dataUrl.length)
  //     return dataUrl
  //   } catch (error) {
  //     const errMsg = error instanceof Error ? error.message : String(error)
  //     const errStack = error instanceof Error ? error.stack : undefined
  //     console.error('makeImageThumbnail: 오류 발생:', error)
  //     // alert('makeImageThumbnail: 오류 발생!\n\n' +
  //     // 'Message: ' + errMsg + '\n\n' +
  //     // 'Stack: ' + (errStack ? errStack.slice(0, 200) : 'N/A'))
  //     throw error
  //   }
  // }
  // return ''

  // if (cropAspectRatio) {
  //   image = await crop(file, cropAspectRatio)
  // }
  // try {
  //   const metaData = await loadImage.parseMetaData(image)

  //   const result = await loadImage(image, {
  //     maxWidth,
  //     maxHeight,
  //     canvas: true,
  //   })

  //   const maxSize = 50_000
  //   if (!quality) {
  //     quality = 0.8
  //   }

  //   let thumbnail = ''
  //   while (quality > 0.2) {
  //     thumbnail = toDataURL(result, quality)
  //     if (thumbnail.length <= maxSize) {
  //       return thumbnail
  //     }
  //     quality -= 0.1
  //   }
  //   return thumbnail
  // } catch (error) {
  //   console.error('makeImageThumbnail: loadImage error', error)
  //   return ''
  // }
}

// // 파일/Blob을 받아 리사이즈된 Blob 반환
// async function resizeImage (fileOrBlob: File | Blob, opts: {
//   maxWidth?: number
//   maxHeight?: number // 비율 유지하며 최대 크기 제한
//   type?: string
//   quality?: number
// }) {
//   try {
//     const inputInfo = {
//       inputType: fileOrBlob.constructor.name,
//       size: fileOrBlob.size,
//       type: fileOrBlob.type,
//       opts,
//     }
//     // alert('[resizeImage] 시작\n' +
//     //   'Type: ' + inputInfo.inputType + '\n' +
//     //   'Size: ' + inputInfo.size + '\n' +
//     //   'MIME: ' + inputInfo.type + '\n' +
//     //   'MaxW: ' + opts.maxWidth + ', MaxH: ' + opts.maxHeight)

//     const { maxWidth, maxHeight, type = 'image/jpeg', quality = 0.9 } = opts

//     // EXIF 회전 반영해서 디코딩
//     // 일부 환경(Safari/WebView/Capacitor)에서는 File/Blob의 realm이 달라서 createImageBitmap가 "Blob이 아님" 오류를 낼 수 있음.
//     // 항상 현재 realm의 순수 Blob으로 재구성하고, createImageBitmap 실패 시 HTMLImageElement로 폴백.
//     const blob = await ensureRealmBlob(fileOrBlob)
//     // alert('[resizeImage] Blob 변환 완료\nSize: ' + blob.size + '\nType: ' + blob.type)

//     let drawSource: CanvasImageSource
//     let sw: number
//     let sh: number
//     let bitmapToClose: ImageBitmap | null = null

//     if ('createImageBitmap' in window) {
//       try {
//         // alert('[resizeImage] createImageBitmap 시도 중...')
//         const bitmap = await window.createImageBitmap(blob)
//         // alert('[resizeImage] createImageBitmap 성공\n' + bitmap.width + ' x ' + bitmap.height)
//         drawSource = bitmap
//         sw = bitmap.width
//         sh = bitmap.height
//         bitmapToClose = bitmap
//       } catch (e) {
//         // createImageBitmap를 지원하지 않거나/Blob 브랜드 불일치로 실패 — 이미지 엘리먼트 경로로 폴백
//         const errMsg = e instanceof Error ? e.message : String(e)
//         console.warn('[resizeImage] createImageBitmap 실패, blobToImage로 폴백:', e)
//         // alert('[resizeImage] createImageBitmap 실패!\n폴백 시도 중...\nError: ' + errMsg)
//         const img = await blobToImage(blob)
//         // alert('[resizeImage] blobToImage 성공\n' + (img.naturalWidth || img.width) + ' x ' + (img.naturalHeight || img.height))
//         drawSource = img
//         sw = img.naturalWidth || img.width
//         sh = img.naturalHeight || img.height
//       }
//     } else {
//       // alert('[resizeImage] createImageBitmap 미지원\nblobToImage 사용')
//       const img = await blobToImage(blob)
//       // alert('[resizeImage] blobToImage 성공\n' + (img.naturalWidth || img.width) + ' x ' + (img.naturalHeight || img.height))
//       drawSource = img
//       sw = img.naturalWidth || img.width
//       sh = img.naturalHeight || img.height
//     }

//     const r = Math.min(
//       maxWidth ? maxWidth / sw : 1,
//       maxHeight ? maxHeight / sh : 1,
//     )
//     const dw = Math.round(sw * r)
//     const dh = Math.round(sh * r)

//     if (window.OffscreenCanvas) {
//       // alert('[resizeImage] OffscreenCanvas\n' + sw + 'x' + sh + ' → ' + dw + 'x' + dh)
//       const canvas = new OffscreenCanvas(dw, dh)

//       const ctx = canvas.getContext('2d') as unknown as CanvasRenderingContext2D
//       if (!ctx) {
//         console.error('[resizeImage] OffscreenCanvas context 생성 실패')
//         // alert('[resizeImage] ERROR!\nOffscreenCanvas context 생성 실패')
//         return null
//       }

//       // ctx.imageSmoothingEnabled = true
//       // ctx.imageSmoothingQuality = 'high'
//       ctx.drawImage(drawSource as CanvasImageSource, 0, 0, dw, dh)
//       bitmapToClose?.close?.()

//       // eslint-disable-next-line @typescript-eslint/no-explicit-any
//       const resultBlob = await (canvas as any).convertToBlob({ type, quality })
//       // alert('[resizeImage] 완료! (OffscreenCanvas)\nSize: ' + resultBlob.size + ' bytes')
//       return resultBlob as Blob
//     } else {
//       // alert('[resizeImage] HTMLCanvasElement\n' + sw + 'x' + sh + ' → ' + dw + 'x' + dh)
//       const canvas = Object.assign(document.createElement('canvas'), { width: dw, height: dh })
//       const ctx = canvas.getContext('2d')
//       if (!ctx) {
//         console.error('[resizeImage] HTMLCanvasElement context 생성 실패')
//         // alert('[resizeImage] ERROR!\nHTMLCanvasElement context 생성 실패')
//         return null
//       }

//       // ctx.imageSmoothingEnabled = true
//       // ctx.imageSmoothingQuality = 'high'
//       ctx.drawImage(drawSource as CanvasImageSource, 0, 0, dw, dh)
//       bitmapToClose?.close?.()

//       // Blob으로 추출
//       const toBlob = () => new Promise((res) => (canvas as HTMLCanvasElement).toBlob(res, type, quality))

//       const resultBlob = await toBlob()
//       // alert('[resizeImage] 완료! (HTMLCanvasElement)\nSize: ' + (resultBlob ? (resultBlob as Blob).size : 'null') + ' bytes')
//       return resultBlob as Blob
//     }
//   } catch (error) {
//     const errMsg = error instanceof Error ? error.message : String(error)
//     const errStack = error instanceof Error ? error.stack : undefined
//     console.error('[resizeImage] 치명적 오류:', error)
//     console.error('[resizeImage] 오류 상세:', {
//       message: errMsg,
//       stack: errStack,
//       inputSize: fileOrBlob?.size,
//       inputType: fileOrBlob?.type,
//     })
//     alert('[resizeImage] 치명적 오류 발생!\n\n' +
//       'Message: ' + errMsg + '\n\n' +
//       'Input Size: ' + fileOrBlob?.size + '\n' +
//       'Input Type: ' + fileOrBlob?.type + '\n\n' +
//       'Stack: ' + (errStack ? errStack.slice(0, 200) : 'N/A'))
//     throw error
//   }
// }

// Note: fileToBlob is no longer needed since ensureRealmBlob handles conversion


// // Blob → HTMLImageElement 로드 (createImageBitmap 폴백)
// function blobToImage (blob: Blob): Promise<HTMLImageElement> {
//   // alert('[blobToImage] 시작\n' + blob.size + ' bytes\n' + blob.type)
//   return new Promise((resolve, reject) => {
//     const url = URL.createObjectURL(blob)
//     const img = new Image()
//     img.onload = () => {
//       // alert('[blobToImage] 이미지 로드 성공\n' +
//       //   (img.naturalWidth || img.width) + ' x ' + (img.naturalHeight || img.height))
//       URL.revokeObjectURL(url)
//       resolve(img)
//     }
//     img.onerror = (e) => {
//       const errMsg = e ? e.toString() : 'Unknown error'
//       console.error('[blobToImage] 이미지 로드 실패:', e)
//       alert('[blobToImage] 이미지 로드 실패!\n' + errMsg)
//       URL.revokeObjectURL(url)
//       reject(e)
//     }
//     img.src = url
//   })
// }

// export async function getDataUrlFromImageFile (file: File) {
//   const result = await loadImage(file, {
//     canvas: true,
//   })
//   return toDataURL(result, 0.9)
// }

/**
 * 이미지 리사이즈 함수 (최적화 버전)
 *
 * 특징:
 * - 순수 Web API 사용 (최대 호환성)
 * - Android WebView 완벽 지원
 * - 빠른 처리 속도
 * - 비율 유지 리사이즈
 * - 선택적 크롭 지원
 *
 * @param file File, Blob 또는 이미지 URL
 * @param name 결과 파일명
 * @param maxWidth 최대 너비
 * @param maxHeight 최대 높이
 * @param cropAspectRatio 크롭 비율 (선택사항, 예: 1 = 정사각형, 16/9 = 와이드)
 * @param quality JPEG 품질 0.0~1.0 (기본값: 0.7)
 * @returns File 형태의 객체
 */

export async function resizeImageFile (file: File | Blob | string | ImageBlob, name: string, maxWidth: number, maxHeight: number, cropAspectRatio?: number, quality?: number): Promise<File> {
  const blob = await resizeImageFileToBlob(file, name, maxWidth, maxHeight, cropAspectRatio, quality)
  return await convertBlobToFile(blob, name)
}

export async function resizeImageFileToDataUrl (file: File | Blob | string | ImageBlob, name: string, maxWidth: number, maxHeight: number, cropAspectRatio?: number, quality?: number): Promise<string> {
  const blob = await resizeImageFileToBlob(file, name, maxWidth, maxHeight, cropAspectRatio, quality)
  return await convertBlobToDataUrl(blob)
}

async function resizeImageFileToBlob (file: File | Blob | string | ImageBlob, name: string, maxWidth: number, maxHeight: number, cropAspectRatio?: number, quality?: number): Promise<Blob> {
  // SVG는 리사이즈하지 않음
  if (file instanceof File && file.type === 'image/svg+xml') {
    return file
  }

  const iBlob = await getImageBlob(file)
  return await resizeImageBlob(iBlob, name, maxWidth, maxHeight, cropAspectRatio, quality)
}

async function resizeImageBlob (iBlob: ImageBlob, name: string, maxWidth: number, maxHeight: number, cropAspectRatio?: number, quality?: number): Promise<Blob> {

  // 기본 품질 설정
  if (!quality) {
    quality = 0.7
  }

  const maxSize = 50_000

  try {
    // 이미지 유효성 검사
    const img = iBlob.image
    if (!img || !img.width || !img.height) {
      console.error('[attachment:image] resizeImageBlob: 유효하지 않은 이미지입니다.')
      throw new Error('Invalid image: width or height is 0')
    }

    // 크롭이 필요한 경우 크롭 처리
    let sourceWidth = img.width
    let sourceHeight = img.height
    let sourceX = 0
    let sourceY = 0

    if (cropAspectRatio) {
      const currentRatio = img.width / img.height

      if (currentRatio > cropAspectRatio) {
        // 가로가 더 긴 경우 - 가로를 자름
        sourceWidth = img.height * cropAspectRatio
        sourceX = (img.width - sourceWidth) / 2
      } else if (currentRatio < cropAspectRatio) {
        // 세로가 더 긴 경우 - 세로를 자름
        sourceHeight = img.width / cropAspectRatio
        sourceY = (img.height - sourceHeight) / 2
      }
    }

    // 리사이즈 비율 계산
    const scale = Math.min(
      maxWidth / sourceWidth,
      maxHeight / sourceHeight,
      1, // 확대는 하지 않음
    )

    const targetWidth = Math.round(sourceWidth * scale)
    const targetHeight = Math.round(sourceHeight * scale)

    //   sourceX,
    //   sourceY,
    //   sourceWidth,
    //   sourceHeight,
    //   scale,
    //   targetWidth,
    //   targetHeight,
    // })

    // Canvas로 리사이즈 및 크롭
    const canvas = document.createElement('canvas')
    canvas.width = targetWidth
    canvas.height = targetHeight

    const ctx = canvas.getContext('2d')
    if (!ctx) {
      console.error('[attachment:image] resizeImageBlob: 캔버스 컨텍스트 생성 실패')
      throw new Error('Canvas context creation failed')
    }

    // 고품질 리샘플링 설정
    ctx.imageSmoothingEnabled = true
    ctx.imageSmoothingQuality = 'high'

    // 이미지 그리기 (크롭 영역만)
    ctx.drawImage(
      img,
      sourceX, sourceY, sourceWidth, sourceHeight, // 소스 영역 (크롭)
      0, 0, targetWidth, targetHeight, // 대상 영역 (리사이즈)
    )

    // Blob으로 변환
    let resultBlob: Blob
    do {
      resultBlob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(
          (blob) => {
            if (blob) {
            //   resultSize: blob.size,
            //   resultType: blob.type,
            // })
              resolve(blob)
            } else {
              console.error('[attachment:image] resizeImageBlob: Canvas toBlob 실패 - null 반환')
              reject(new Error('Canvas toBlob failed - returned null'))
            }
          },
          'image/jpeg',
          quality,
        )
      })
    } while (resultBlob.size > maxSize && quality! > 0.2 && (quality = quality! - 0.1))
    return resultBlob
  } catch (error) {
    console.error('[attachment:image] resizeImageBlob: Error:', error)
    // console.error('[attachment:image] resizeImageBlob: Error details:', {
    //   name: name,
    //   maxWidth: maxWidth,
    //   maxHeight: maxHeight,
    //   imageWidth: iBlob.image?.width,
    //   imageHeight: iBlob.image?.height,
    // })
    throw error
  }
}

export async function cappedResizeImageFile (input: File | Blob | string | ImageBlob, name: string, maxResolution: number, quality?: number): Promise<{file: File, width: number, height: number}> {

  const iBlob = await getImageBlob(input)
  let { width, height } = getImageSize(iBlob)
  const resolution = width * height
  if (resolution <= maxResolution) {
    // 리사이즈 불필요
    return { file: iBlob.file ?? convertBlobToFile(iBlob.blob, name), width, height }
  }
  const scale = Math.sqrt(maxResolution / resolution)
  width = Math.round(width * scale)
  height = Math.round(height * scale)

  const blob = await resizeImageBlob(iBlob, name, width, height, undefined, quality)
  const file = convertBlobToFile(blob, name)
  return { file, width, height }
}

// /**
//  * 기존 resizeImageFile 함수 (blueimp-load-image 사용)
//  * @deprecated 호환성 문제로 resizeImageFile 사용 권장
//  */
// export async function resizeFileOld (file: File | Blob | string, name: string, maxWidth: number, maxHeight: number, cropAspectRatio?: number, quality?: number): Promise<File> {
//   if (file instanceof File && file.type === 'image/svg+xml') {
//     return file
//   }

//   let image = file

//   if (cropAspectRatio) {
//     image = await crop(file, cropAspectRatio)
//   }
//   const result = await loadImage(image, {
//     maxWidth,
//     maxHeight,
//     canvas: true,
//   })

//   if (!quality) {
//     quality = 0.7
//   }
//   const newFile = convertBlobToFile(await toBlob(result, quality), name)
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   return newFile as any as File
// }

// async function crop (file: Blob | string, aspectRatio: number) {
//   const result = await loadImage(file, {
//     aspectRatio,
//   })
//   return await toBlob(result, 1.0)
// }

// function toDataURL (result: loadImage.LoadImageResult, quality: number) {
//   const canvas = result.image as unknown as HTMLCanvasElement
//   return canvas.toDataURL('image/jpeg', quality)
// }

// async function toBlob (result: loadImage.LoadImageResult, quality: number) {
//   const canvas = result.image as unknown as HTMLCanvasElement
//   return new Promise<Blob>((resolve, reject) => {
//     canvas.toBlob((blob) => {
//       blob ? resolve(blob) : reject(undefined)
//     }, 'image/jpeg', quality)
//   })
// }

/**
 * Blob에서 이미지를 로드 (EXIF 회전 자동 처리)
 */
async function loadImageFromBlob (blob: Blob): Promise<HTMLImageElement> {

  return new Promise((resolve, reject) => {
    if (!blob || blob.size === 0) {
      reject(new Error('Invalid blob: size is 0'))
      return
    }

    const url = URL.createObjectURL(blob)
    const img = new Image()

    // 타임아웃 설정 (10초)
    const timeout = setTimeout(() => {
      URL.revokeObjectURL(url)
      reject(new Error('Image load timeout'))
    }, 10000)

    img.onload = () => {
      clearTimeout(timeout)
      URL.revokeObjectURL(url)

      if (img.width === 0 || img.height === 0) {
        reject(new Error('Invalid image: dimensions are 0'))
      } else {
        resolve(img)
      }
    }

    img.onerror = (error) => {
      clearTimeout(timeout)
      URL.revokeObjectURL(url)
      console.error('[loadImageFromBlob] Failed to load image:', error)
      reject(new Error('Failed to load image from blob: ' + error))
    }

    img.src = url
  })
}

// EXIF 관련 함수들은 현재 사용하지 않음 (향후 필요시 활성화)
// 브라우저의 자동 EXIF 처리를 신뢰하는 것이 더 호환성이 좋음
